import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPagePickerConfig, IPagePickerType } from './typings';
import { mPagePickerDashStyle, mPagePickerSpaceStyle, range, unique } from './utils';

@Component({
  selector: 'm-page-picker',
  template: `
    <div class="m-page-picker">
      <div>应用范围设置</div>
      <nz-radio-group [(ngModel)]="mType" (ngModelChange)="onTypeChange()">
        <label class="m-page-picker-choose-item" nz-radio nzValue="all" [hidden]="!labelAllVisible">
          {{ labelAllText }}
        </label>
        <label class="m-page-picker-choose-item" nz-radio nzValue="current" [hidden]="!labelCurrentVisible">
          {{ labelCurrentText }}
        </label>
        <label class="m-page-picker-choose-item" nz-radio nzValue="part" [hidden]="!labelPartVisible">
          {{ labelPartText }}
          <input
            *ngIf="mType === 'part'"
            class="m-page-picker-text"
            nzSize="small"
            type="text"
            nz-input
            [(ngModel)]="mPageText"
            (ngModelChange)="onPageTextChange()"
            placeholder="请输入 1-3 或 1 3"
          />
        </label>
      </nz-radio-group>
      <div class="m-page-picker-bottom" [ngStyle]="{ marginTop: mType === 'part' ? '16px' : 0 }">
        <button nz-button nzType="default" (click)="onCancel()">取消</button>
        <button nz-button nzType="primary" [disabled]="!isPageTextValid" (click)="onConfirm()">确认</button>
      </div>
    </div>
  `,
  preserveWhitespaces: false
})
export class MPageComponent {
  @Input() mType: IPagePickerType = 'all';
  @Input() mTotal = 0;
  @Input() mPageText = '';
  @Input() mPageIndex = 0;
  @Input() mPageConfig?: Partial<IPagePickerConfig>;

  @Output() readonly mTypeChange = new EventEmitter<IPagePickerType>();
  @Output() readonly mPageTextChange = new EventEmitter<string>();

  @Output() readonly mCancel = new EventEmitter<void>();
  @Output() readonly mConfirm = new EventEmitter<number[]>();

  pageNumbers: number[] = [];

  get isPageTextValid(): boolean {
    let valid = false;
    if (this.mType === 'all' || this.mType === 'current') {
      valid = true;
    }

    if (this.mType === 'part') {
      valid = mPagePickerDashStyle.test(this.mPageText) || mPagePickerSpaceStyle.test(this.mPageText);
    }

    return valid;
  }

  get labelAllText(): string {
    return this.mPageConfig?.all?.text ?? '所有页';
  }

  get labelPartText(): string {
    return this.mPageConfig?.part?.text ?? '选择页';
  }

  get labelCurrentText(): string {
    return this.mPageConfig?.current?.text ?? '当前页';
  }

  get labelAllVisible(): boolean {
    return this.mPageConfig?.all?.visible ?? true;
  }

  get labelPartVisible(): boolean {
    return this.mPageConfig?.part?.visible ?? true;
  }

  get labelCurrentVisible(): boolean {
    return this.mPageConfig?.current?.visible ?? true;
  }

  onCancel(): void {
    this.mCancel.emit();
  }

  onConfirm(): void {
    if (this.isPageTextValid) {
      this.splitPages();
      this.mConfirm.emit(this.pageNumbers);
    }
  }

  onTypeChange(): void {
    this.mTypeChange.emit(this.mType);
  }

  onPageTextChange(): void {
    this.mPageTextChange.emit(this.mPageText);
  }

  private splitPages(): void {
    if (this.mType === 'all') {
      this.pageNumbers = range(1, this.mTotal + 1);
    }

    if (this.mType === 'current') {
      this.pageNumbers = [this.mPageIndex];
    }

    if (this.mType === 'part') {
      const _afterTrim = this.mPageText.trim();
      if (mPagePickerDashStyle.test(_afterTrim)) {
        const pageRange = _afterTrim.split('-').map(e => Number(e));
        const start = Math.min(...pageRange);
        const end = Math.max(...pageRange);
        this.pageNumbers = range(start, end + 1);
      }

      if (mPagePickerSpaceStyle.test(_afterTrim)) {
        this.pageNumbers = unique(_afterTrim.split(/\s+/).map(e => Number(e))).filter(e => e <= this.mTotal);
      }
    }
  }
}
